import React, { useMemo } from 'react';
import styled from 'astroturf/react';
import AvatarBase from 'js/social/shared/Avatar';
import { Body } from 'js/design_system/Body';
import { FollowableUser, Tag } from 'js/social/shared/types';
import { Autocomplete } from 'js/social/shared/SocialEditor/Autocomplete';
import { TAG_MAX } from 'js/social/shared/SocialEditor/utils';
import _Avatar from "TagSelector-Avatar.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/SocialEditor/TagSelector.tsx?styleId=Avatar";
import _Details from "TagSelector-Details.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/SocialEditor/TagSelector.tsx?styleId=Details";
import _Affiliation from "TagSelector-Affiliation.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/SocialEditor/TagSelector.tsx?styleId=Affiliation";


const Avatar = /*#__PURE__*/styled(AvatarBase, null, {
  displayName: "Avatar",
  styles: _Avatar
});

const Details = /*#__PURE__*/styled("div", null, {
  displayName: "Details",
  styles: _Details
});

const Affiliation = /*#__PURE__*/styled(Body, null, {
  displayName: "Affiliation",
  styles: _Affiliation
});

type Props = {
  anchorTop?: number;
  anchorLeft?: number;
  users: FollowableUser[];
  tags: Tag[];
  loading: boolean;
  activeIndex: number;
  onActiveIndexChange: (activeIndex: number) => void;
  onSelect: (tag: FollowableUser) => void;
};

export const TagSelector: React.FC<Props> = ({
  anchorTop = 0,
  anchorLeft = 0,
  users,
  tags,
  loading,
  activeIndex,
  onActiveIndexChange,
  onSelect,
}) => {
  const message = useMemo(() => {
    if (tags.length >= TAG_MAX) {
      return "You've reached the limit of people you can add.";
    } else if (users.length <= 0) {
      return 'No results found.';
    }
    return undefined;
  }, [tags, users]);

  return (
    <Autocomplete
      anchorTop={anchorTop}
      anchorLeft={anchorLeft}
      items={users}
      message={message}
      activeIndex={activeIndex}
      loading={loading}
      keyExtractor={(user) => user.id}
      renderItem={(user) => (
        <>
          <Avatar
            fullName={user.displayName}
            photoUrl={user.photo}
            profileUrl={user.url}
          />
          <Details>
            <Body size="md" bold>
              {user.displayName}
            </Body>
            <Affiliation size="sm">{user.university?.displayName}</Affiliation>
          </Details>
        </>
      )}
      onActiveIndexChange={onActiveIndexChange}
      onSelect={onSelect}
    />
  );
};
